import { onMounted, watch, computed } from 'vue'
import { useStore } from 'vuex'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: 'ConfirmChanges',
    setup() {
        const store = useStore()
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        let first, last, close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        // button will execute the method set in store by: 'set_page_overlay_content_data' mutation
        const confirmAction = function () {
            store.state.main.page_overlay_content_data.callback()
        }

        const cancelAction = function () {
            store.dispatch('main/closePageOverlay')
        }

        onMounted(() => {
            first = document.querySelector('.kb-button[data-order="first"]')
            last = document.querySelector('.kb-button[data-order="last"]')
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        return {
            cancelAction,
            confirmAction,
            tabTrap,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'ConfirmChanges',
                    labelKey
                })
        }
    }
}
